import { Loader } from "@googlemaps/js-api-loader"; 
import haversine from 'haversine-distance'


export const locationsList = () => {

	

	const lListModules = [].slice.call(document.querySelectorAll('.m__llist'));

	if ("IntersectionObserver" in window) {

		var lazyLlistObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(llistObserver) {
				if (llistObserver.isIntersecting) {

					let llist = llistObserver.target;

					let lListInput 		= llist.querySelector('.m__llist__filter-input input'), //Text input for location search
					lListSubmit 	= llist.querySelector('.m__llist__filter-input-submit'), //Submit button linked to text input
					lListGeo   		= llist.querySelector('.m__llist__filter-input-geo'), //Get users location link
					lListContainer 	= llist.querySelector('.m__llist__locations-items '), //Locations cards container
					lListLocations 	= llist.querySelectorAll('.m__llist__card'), //Location cards
					lListData		= llist.querySelector('.m__llist__filter-data'), //Hidden element to hold search query data
					lListReveal		= llist.querySelector('.js__llist-reveal-all'),
					showRegionsPopup = llist.querySelector('.js__show-regions-popup'), //Trigger for the regions popup;
					filterLocationsByRegionTrigger = llist.querySelector('.js__filter-regions'), //Trigger to filter by selected region(s)
					regionSelectors = llist.querySelectorAll('.m__llist__regions-toggle input'), //Region filters
					regionsPopup = llist.querySelector('.m__llist__regions'), //Regions popup element
					resetFilters = llist.querySelector('.js__locations-reset');

					//Init GoogleMaps autocomplete on lListInput
					const googleLoader = new Loader({
					  apiKey: "AIzaSyCC0nJSV1K42Cxhx4raqVXHiRWr9hfOSQk",
					  version: "weekly",
					  libraries: ["places"]
					});
					let boundsCenter = {
						lat:52.776139,
						lng:-0.862733,
					}
					googleLoader.load()
				  	.then((google) => {
					    let options = {
					        fields: ["formatted_address", "geometry", "name"],
					        bounds:{
							  north: boundsCenter.lat + 1,
							  south: boundsCenter.lat - 1,
							  east: boundsCenter.lng + 1,
							  west: boundsCenter.lng - 1,
							},
					        strictBounds: false,
					      };
				      	let lListAutocomplete = new google.maps.places.Autocomplete(lListInput, options);

				      	llist.classList.remove('loading');

				      	lListAutocomplete.addListener("place_changed", () => {
				      		let selectedPlace = lListAutocomplete.getPlace();

				      		lListData.dataset.lat = selectedPlace.geometry.location.lat();
				      		lListData.dataset.lng = selectedPlace.geometry.location.lng();

				      		llist.classList.add('active');

				      		//Add distance between users selected address & eachlocation
				      		lListLocations.forEach((location) => {

				      			let a = { lat: lListData.dataset.lat, lng: lListData.dataset.lng }, 
				      				b = { lat: location.dataset.lat, lon: location.dataset.lng };

				      			location.dataset.distance = haversine(a, b);

				      		});

				      		//Now order the locations by that lat lng
				      		Array.from(lListLocations)
				      		  .sort(({dataset: {distance: a}}, {dataset: {distance: b}}) => Number(a) - Number(b)) // `Number(b) - Number(a)` to reverse the sort.
				      		  .forEach((item) => item.parentNode.appendChild(item));

				      		//Add manual reveal of items in case of scroll fade in issues
				      		llist.querySelector('.m__llist__locations').classList.add('fade-in');
				      	})
				  	})
				  	.catch(e => {
				   		// do something
				  	});

					//Add event listener for lListGeo
					lListGeo.addEventListener('click', (event) => {
						event.preventDefault();

						//Geolocation API
						navigator.geolocation.getCurrentPosition(
						(pos) => {
							lListData.dataset.lat 	= pos.coords.latitude;
							lListData.dataset.lng 	= pos.coords.longitude;
							lListInput.value 		= 'Your Location';
						}, 
						(error) => {
							alert('Failed to access location');
						}, 
						{
						  enableHighAccuracy: true,
						  timeout: 5000,
						  maximumAge: 0,
						});

					})


					//Add eventlistener for lListSubmit
					lListSubmit.addEventListener('click',(event) => {
						event.preventDefault();

						//Check to see if an address has been picked
						if(lListData.dataset.lng > '' && lListData.dataset.lat > ''){

							//Make this module fully active 
							llist.classList.add('active');

							//Add distance between users selected address & eachlocation
							lListLocations.forEach((location) => {

								let a = { lat: lListData.dataset.lat, lng: lListData.dataset.lng }, 
									b = { lat: location.dataset.lat, lon: location.dataset.lng };

								location.dataset.distance = haversine(a, b);

							});

							//Now order the locations by that lat lng
							Array.from(lListLocations)
							  .sort(({dataset: {distance: a}}, {dataset: {distance: b}}) => Number(a) - Number(b)) // `Number(b) - Number(a)` to reverse the sort.
							  .forEach((item) => item.parentNode.appendChild(item));

							//Add manual reveal of items in case of scroll fade in issues
							llist.querySelector('.m__llist__locations').classList.add('fade-in');
						}
					})

					//Add listener to reveal all
					if(lListReveal){
						lListReveal.addEventListener('click',(event)=>{
							event.preventDefault();
							event.target.classList.add('triggered');
							llist.classList.add('active');
						})
					}


					//Handle Regions popup
					if(showRegionsPopup){
						showRegionsPopup.addEventListener('click',(event) => {
							event.preventDefault();
							regionsPopup.classList.add('active');
							document.querySelector('body').classList.add('js__popup-active');
							document.querySelector('#js__body').classList.add('js__popup-active'); 

						})
					}
					//Handle regions selector styling
					regionSelectors.forEach((regionSelector) => {
						regionSelector.addEventListener('change',(e) => {
							if(e.target.checked){
								e.target.parentElement.classList.add('active');
							}else{
								e.target.parentElement.classList.remove('active');
							}
						})
					})
					//Handle apply selected filters
					if(filterLocationsByRegionTrigger){
						filterLocationsByRegionTrigger.addEventListener('click',(event) => {
							event.preventDefault();

							//First hide all locations
							lListLocations.forEach((location) => {
								location.classList.add('hidden');
							})

							//Check which regions we're showing 
							let checkedRegions = [...document.querySelectorAll('.m__llist__regions-toggle input:checked')];

							//Loop through and only show locations for that region
							let displayingRegions = 0;
							checkedRegions.forEach((selectedRegion) => {
								lListLocations.forEach((location) => {
									if(location.dataset.region == selectedRegion.value){
										location.classList.remove('hidden');
										displayingRegions++;
									}
								})
							})	
							//No regions found
							if(displayingRegions == 0){
								alert('No venues found.');
								lListLocations.forEach((location) => {
									location.classList.remove('hidden');
								})
							}

							//Hide the regions popup
							regionsPopup.classList.remove('active');
							document.querySelector('body').classList.remove('js__popup-active');
							document.querySelector('#js__body').classList.remove('js__popup-active'); 



							//Make sure the feed is active!
							llist.classList.add('active');

							//Hide the view all button
							if(lListReveal){
								lListReveal.classList.add('triggered');
							}
						})
					}


					//Reset filters
					if(resetFilters){
						resetFilters.addEventListener('click',(event) => {
							lListLocations.forEach((location) => {
								location.classList.remove('hidden');
							})
						})
					}

					//Remove this map from the observer, as it's now loaded in
					lazyLlistObserver.unobserve(llist);
					
				}
			});
		});

		lListModules.forEach((llistModule) => {
			lazyLlistObserver.observe(llistModule);
		})

	}

	//Reset filters
	const resetFilters = document.querySelectorAll('.js__locations-reset');
	if ( resetFilters ) {
		resetFilters.forEach(trigger => {
			trigger.addEventListener('click',(event) => {				
				const triggerSection = trigger.closest('.m__llist');
				const lListLocations = triggerSection.querySelectorAll('.m__llist__card');

				// First hide all locations
				lListLocations.forEach(location => {
					location.classList.add('hidden');
				});

				//Now order the locations by the original order
				Array.from(lListLocations)
				.sort(({dataset: {order: a}}, {dataset: {order: b}}) => Number(a) - Number(b)) // `Number(b) - Number(a)` to reverse the sort.
				.forEach((item) => item.parentNode.appendChild(item));	
				
				// Clear any existing region filters
				const regionFiltersToggle = triggerSection.querySelectorAll('.m__llist__regions-toggle');
				if ( regionFiltersToggle ) {
					regionFiltersToggle.forEach(toggle => {
						// Remove active state from region filters
						toggle.classList.remove('active');

						// Uncheck the toggle checkbox
						toggle.firstElementChild.checked = false;
					});
				}

				// Show all the locations again
				lListLocations.forEach(location => {
					// Reset the data-distance attribute to 0
					location.setAttribute('data-distance', 0);

					// Show the location
					location.classList.remove('hidden');
				});

				// Clear the search field input
				const locationSearch = triggerSection.querySelector('.pac-target-input');
				locationSearch.value = '';
			})
		});
	}
}



function comparator(a, b) {
	 if (a.dataset.subject < b.dataset.subject)
                return -1;
            if (a.dataset.subject > b.dataset.subject)
                return 1;
            return 0;
}

